import React, { useState } from "react";
import { Box } from "@mui/material";

import {
  PXDX,
  DEMOGRAPHICS,
  DEPENDENCY,
  HISTORY_TRANSLATION,
  INCOMPATIBILITY,
  PLACE_OF_SERVICE,
  UNLISTED_PA,
  tabOrder,
  POLICY_STATUS_EDIT,
  FAILED_VALIDATION,
} from "../Constants/PolicyTranslationConstants";
import TranslationReviewTable from "../PolicyTables/TranslationReviewTable";
import PxDxTable from "../PolicyTables/PxDxTable";
import DemographicsTable from "../PolicyTables/DemographicsTable";
import PlaceOfServiceTable from "../PolicyTables/PlaceOfServiceTable";
import DependencyTable from "../PolicyTables/DependencyTable";
import HistoryTranslationTable from "../PolicyTables/HistoryTranslationTable";
import IncompatibilityTable from "../PolicyTables/IncompatibilityTable";
import PolicyHistoryTable from "../PolicyTables/PolicyHistoryTable";
import UnlistedPATable from "../PolicyTables/UnlistedPATable";

/**
 * PolicyTabsComponent
 * Shared between PolicyTranslation and UseCases
 */
const PolicyTabsComponent = ({
  gridHeight,
  policyRules,
  tabValue,
  editable,
  addNewRows,
  duplicateRow,
  updateRulesAfterEdit,
  dxLimitationValues,
  availableProcedureCodes,
  newRowStructure,
  selectedCC,
  setSelectedCC,
  selectedVariance,
  setSelectedVariance,
  chips,
  handleDelete,
  setLoading,
  policyData,
  pageComponent,
  handleRemoveInvalidRow,
  endExistingRule,
  pxdxRows,
  historyRows,
  inCompabilityRows,
  demographicRows,
  dependencyRows,
}) => {
  const dxLimitationForPXDX = dxLimitationValues.filter(
    (v) => v.tabDisplayText === PXDX
  );
  const dxLimitationForOtherTable = dxLimitationValues.filter(
    (v) => !v.tabDisplayText.trim().length
  );

  return (
    <>
      <Box className={"table"}>
        {tabValue === tabOrder.get(PXDX) && (
          <PxDxTable
            gridHeight={gridHeight}
            setLoading={setLoading}
            rows={pxdxRows}
            editable={editable}
            addNewRows={addNewRows}
            duplicateRow={duplicateRow}
            updateRulesAfterEdit={updateRulesAfterEdit}
            availableProcedureCodes={availableProcedureCodes}
            chips={chips}
            newRowStructure={newRowStructure}
            selectedCC={selectedCC}
            setSelectedCC={setSelectedCC}
            selectedVariance={selectedVariance}
            setSelectedVariance={setSelectedVariance}
            handleDelete={handleDelete}
            policyData={policyData}
            dxLimitationValues={dxLimitationForPXDX}
            pageComponent={pageComponent}
            handleRemoveInvalidRow={handleRemoveInvalidRow}
            endExistingRule={endExistingRule}
          />
        )}
        {tabValue === tabOrder.get(DEMOGRAPHICS) && (
          <DemographicsTable
            gridHeight={gridHeight}
            setLoading={setLoading}
            editable={editable}
            rows={demographicRows}
            addNewRows={addNewRows}
            duplicateRow={duplicateRow}
            updateRulesAfterEdit={updateRulesAfterEdit}
            availableProcedureCodes={availableProcedureCodes}
            chips={chips}
            newRowStructure={newRowStructure}
            selectedCC={selectedCC}
            setSelectedCC={setSelectedCC}
            handleDelete={handleDelete}
            policyData={policyData}
            pageComponent={pageComponent}
            dxLimitationValues={dxLimitationForOtherTable}
            handleRemoveInvalidRow={handleRemoveInvalidRow}
            endExistingRule={endExistingRule}
          />
        )}
        {tabValue === tabOrder.get(DEPENDENCY) && (
          <DependencyTable
            gridHeight={gridHeight}
            setLoading={setLoading}
            editable={editable}
            rows={dependencyRows}
            addNewRows={addNewRows}
            duplicateRow={duplicateRow}
            updateRulesAfterEdit={updateRulesAfterEdit}
            availableProcedureCodes={availableProcedureCodes}
            chips={chips}
            newRowStructure={newRowStructure}
            selectedCC={selectedCC}
            setSelectedCC={setSelectedCC}
            handleDelete={handleDelete}
            policyData={policyData}
            pageComponent={pageComponent}
            handleRemoveInvalidRow={handleRemoveInvalidRow}
            endExistingRule={endExistingRule}
          />
        )}
        {tabValue === tabOrder.get(HISTORY_TRANSLATION) && (
          <HistoryTranslationTable
            gridHeight={gridHeight}
            setLoading={setLoading}
            editable={editable}
            rows={historyRows}
            addNewRows={addNewRows}
            duplicateRow={duplicateRow}
            updateRulesAfterEdit={updateRulesAfterEdit}
            availableProcedureCodes={availableProcedureCodes}
            chips={chips}
            newRowStructure={newRowStructure}
            selectedCC={selectedCC}
            setSelectedCC={setSelectedCC}
            handleDelete={handleDelete}
            policyData={policyData}
            pageComponent={pageComponent}
            handleRemoveInvalidRow={handleRemoveInvalidRow}
            endExistingRule={endExistingRule}
          />
        )}
        {tabValue === tabOrder.get(INCOMPATIBILITY) && (
          <IncompatibilityTable
            gridHeight={gridHeight}
            setLoading={setLoading}
            editable={editable}
            rows={inCompabilityRows}
            addNewRows={addNewRows}
            duplicateRow={duplicateRow}
            updateRulesAfterEdit={updateRulesAfterEdit}
            availableProcedureCodes={availableProcedureCodes}
            chips={chips}
            newRowStructure={newRowStructure}
            selectedCC={selectedCC}
            setSelectedCC={setSelectedCC}
            handleDelete={handleDelete}
            policyData={policyData}
            pageComponent={pageComponent}
            dxLimitationValues={dxLimitationForOtherTable}
            handleRemoveInvalidRow={handleRemoveInvalidRow}
            endExistingRule={endExistingRule}
          />
        )}
        {tabValue === tabOrder.get(PLACE_OF_SERVICE) && (
          <PlaceOfServiceTable
            gridHeight={gridHeight}
            setLoading={setLoading}
            editable={editable}
            rows={policyRules[PLACE_OF_SERVICE]}
            addNewRows={addNewRows}
            duplicateRow={duplicateRow}
            updateRulesAfterEdit={updateRulesAfterEdit}
            availableProcedureCodes={availableProcedureCodes}
            chips={chips}
            newRowStructure={newRowStructure}
            selectedCC={selectedCC}
            setSelectedCC={setSelectedCC}
            handleDelete={handleDelete}
            policyData={policyData}
            pageComponent={pageComponent}
            handleRemoveInvalidRow={handleRemoveInvalidRow}
            endExistingRule={endExistingRule}
          />
        )}
        {tabValue === tabOrder.get(UNLISTED_PA) && (
          <UnlistedPATable
            gridHeight={gridHeight}
            setLoading={setLoading}
            editable={editable}
            rows={policyRules[UNLISTED_PA]}
            addNewRows={addNewRows}
            duplicateRow={duplicateRow}
            updateRulesAfterEdit={updateRulesAfterEdit}
            availableProcedureCodes={availableProcedureCodes}
            chips={chips}
            newRowStructure={newRowStructure}
            selectedCC={selectedCC}
            setSelectedCC={setSelectedCC}
            handleDelete={handleDelete}
            policyData={policyData}
            pageComponent={pageComponent}
            handleRemoveInvalidRow={handleRemoveInvalidRow}
            endExistingRule={endExistingRule}
          />
        )}
      </Box>
    </>
  );
};

export default PolicyTabsComponent;
